// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"14dae723","309":"14dae723","543":"14dae723","793":"14dae723","963":"14dae723"}[chunkId] + ".chunk.css";
};